<template>
  <div
    :class="['tw:relative', { fit: !isOverlay }]"
    v-bind="$attrs"
  >
    <!-- NORMAL SLOT -->
    <template v-if="!isOverlay">
      <slot v-if="state === 'done'" />
    </template>

    <!-- OVERLAY MODE -->
    <div
      v-if="isOverlay"
      :aria-hidden="state !== 'done'"
      :class="{ 'tw:invisible': state !== 'done' }"
    >
      <slot />
    </div>

    <template v-if="state !== 'done'">
      <!-- LOADING -->
      <slot
        v-if="state === 'loading'"
        name="loading"
      >
        <div class="absolute-center">
          <QSpinner :size="30" />
        </div>
      </slot>

      <!-- ERROR -->
      <slot
        v-if="state === 'error'"
        name="error"
      >
        <div class="absolute-center tw:flex tw:flex-col">
          <div class="tw:mb-4">
            {{ errorMessage }}
          </div>
          <BaseButton
            :aria-label="getLocaleText('global.try_again')"
            class="tw:m-auto"
            color="primary"
            icon="ion-md-sync"
            :label="getLocaleText('global.try_again')"
            new-design
            @click="$emit('reload')"
          />
        </div>
      </slot>

      <!-- NO DATA -->
      <slot
        v-if="state === 'noData'"
        name="no-data"
        :no-data-message="noDataMessage"
      >
        <div class="absolute-center">
          <div class="text-center">
            {{ noDataMessage }}
          </div>
        </div>
      </slot>
    </template>
  </div>
</template>

<script lang="ts">
export interface DataLoadingWrapperProps {
  errorMessage?: string;
  isOverlay?: boolean;
  noDataMessage?: string;
  state: DataLoadingWrapperState;
}
</script>

<script setup lang="ts">
import { getLocaleText } from "shared/boot/i18n";
import BaseButton from "shared/components/base/BaseButton";
import { type DataLoadingWrapperState } from "shared/types";

withDefaults(defineProps<DataLoadingWrapperProps>(), {
  noDataMessage: () => getLocaleText("global.no_data_available"),
  errorMessage: () => getLocaleText("global.errors.error_loading_data"),
});

defineEmits(["reload"]);
</script>
